import { render, staticRenderFns } from "./user-stat.vue?vue&type=template&id=64f0f258&scoped=true&"
import script from "./user-stat.vue?vue&type=script&lang=js&"
export * from "./user-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f0f258",
  null
  
)

export default component.exports